/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Templatename1Inputs */

const en_entity_templatename1 = /** @type {(inputs: Entity_Templatename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Name`)
};

const de_entity_templatename1 = /** @type {(inputs: Entity_Templatename1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template-Name`)
};

/**
* | output |
* | --- |
* | "Template Name" |
*
* @param {Entity_Templatename1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_templatename1 = /** @type {((inputs?: Entity_Templatename1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Templatename1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_templatename1(inputs)
	return de_entity_templatename1(inputs)
});
export { entity_templatename1 as "entity_templateName" }